export const BILLABLE_ITEM_TYPES = {
	OPTIONALS: 1,
	SERVICES: 2,
	RENTAL: 3,
};
